import {PreviewTemplate} from 'TemplateEditor/PreviewTemplate'
import {WaitPage} from 'event/WaitPage'
import {useEventPreview} from 'event/providers/EventPreviewProvider'
import moment from 'moment'
import React, {useEffect} from 'react'
import {useLocalizedNavigate} from 'i18n/useLocalizedNavigate'
import {routes} from 'routes/routes'

export function Preview() {
  const {event, loading} = useEventPreview()
  const navigate = useLocalizedNavigate()

  useEffect(() => {
    if (!event && !loading) {
      navigate(routes.login)
    }

    if (!event?.paid) {
      navigate(routes.root)
    }
  }, [event, loading, navigate])

  if (!event) return null

  const eventDateTime = moment(
    `${event.date} ${event.time}`,
    'YYYY-MM-DD HH:mm',
  )

  const isEventStartingIn30Minutes =
    eventDateTime.diff(moment(), 'minutes') < 30

  if (
    !isEventStartingIn30Minutes &&
    (!event.page_date || moment(event.page_date).isAfter())
  ) {
    return <WaitPage />
  }

  return <PreviewTemplate event={event} />
}
